import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import "@/index.css";
import App from "@/App";

// The Emergent preview platform injects a "Made with Emergent" badge
// (#emergent-badge) at runtime and can also re-inject it after DOM mutations.
// The customer requested it hidden — enforce with a global CSS rule + a
// MutationObserver that hides any future re-injection.
function killEmergentBadge() {
  const el = document.getElementById("emergent-badge");
  if (!el) return;
  el.style.setProperty("display", "none", "important");
  el.style.setProperty("visibility", "hidden", "important");
  el.setAttribute("aria-hidden", "true");
}
killEmergentBadge();
if (typeof MutationObserver !== "undefined") {
  new MutationObserver(killEmergentBadge).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, refetchOnWindowFocus: false },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster position="top-center" richColors closeButton />
    </QueryClientProvider>
  </React.StrictMode>,
);
